var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.36713 6.1L10.0171 0.45C10.1505 0.316667 10.3088 0.25 10.4921 0.25C10.6755 0.25 10.8338 0.316667 10.9671 0.45C11.1005 0.583333 11.1671 0.741667 11.1671 0.925C11.1671 1.10833 11.1005 1.26667 10.9671 1.4L4.8338 7.53333C4.70046 7.66667 4.54491 7.73333 4.36713 7.73333C4.18935 7.73333 4.0338 7.66667 3.90046 7.53333L1.0338 4.66667C0.900464 4.53333 0.836575 4.375 0.84213 4.19167C0.847686 4.00833 0.91713 3.85 1.05046 3.71667C1.1838 3.58333 1.34213 3.51667 1.52546 3.51667C1.7088 3.51667 1.86713 3.58333 2.00046 3.71667L4.36713 6.1Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightTick);
export default __webpack_public_path__ + "static/media/rightTick.61cc0f65d49ee51e180cb66607736e07.svg";
export { ForwardRef as ReactComponent };